module.exports = {"411425100":"城关镇","411425101":"界沟镇","411425102":"木兰镇","411425103":"杜集镇","411425104":"谷熟镇","411425105":"大杨集镇","411425107":"利民镇","411425108":"张集镇","411425109":"站集镇","411425110":"稍岗镇","411425111":"乔集镇","411425200":"黄冢乡","411425201":"沙集乡","411425202":"店集乡","411425204":"闻集乡","411425205":"芒种桥乡","411425207":"刘店乡","411425208":"大候乡","411425210":"城郊乡","411425211":"郑集乡","411425212":"李老家乡","411425214":"镇里固乡","411425215":"古王集乡","411425219":"刘集乡","411425221":"田庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411425.json
// module id = 1781
// module chunks = 0